import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(form.email, form.password);
      if (data.kind !== "admin") { toast.error("Not an admin account"); setLoading(false); return; }
      toast.success("Welcome back");
      nav("/admin");
    } catch (e) { toast.error(apiErr(e)); setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="font-display text-3xl font-extrabold text-white tracking-tight">Qava<span className="text-[#FF6A1A]">.</span></div>
          <p className="text-zinc-500 text-sm mt-2">Admin Dashboard</p>
        </div>
        <form onSubmit={submit} className="bg-zinc-900 rounded-2xl p-7 space-y-4 border border-zinc-800">
          <div><Label className="text-zinc-300">Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-zinc-800 border-zinc-700 text-white mt-1.5" data-testid="admin-email" /></div>
          <div><Label className="text-zinc-300">Password</Label><Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-zinc-800 border-zinc-700 text-white mt-1.5" data-testid="admin-password" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-white text-zinc-900 hover:bg-zinc-200 h-11" data-testid="admin-login-submit">{loading ? "Signing in..." : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
